/**
 * Defines the constants used by the Routing module.
 * @file
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */

export const VUEX_ROUTING_ENTER_AUTHENTICATED_ROUTE       = 'VUEX_ROUTING_ENTER_AUTHENTICATED_ROUTE'
export const VUEX_ROUTING_ENTER_CALENDAR                  = 'VUEX_ROUTING_ENTER_CALENDAR'
export const VUEX_ROUTING_ENTER_CALENDAR_ITEM             = 'VUEX_ROUTING_ENTER_CALENDAR_ITEM'
export const VUEX_ROUTING_ENTER_CALENDAR_ITEMS            = 'VUEX_ROUTING_ENTER_CALENDAR_ITEMS'
export const VUEX_ROUTING_ENTER_DOC                       = 'VUEX_ROUTING_ENTER_DOC'
export const VUEX_ROUTING_ENTER_DOCS                      = 'VUEX_ROUTING_ENTER_DOCS'
export const VUEX_ROUTING_ENTER_EVENT                     = 'VUEX_ROUTING_ENTER_EVENT'
export const VUEX_ROUTING_ENTER_EVENTS                    = 'VUEX_ROUTING_ENTER_EVENTS'
export const VUEX_ROUTING_ENTER_JOB                       = 'VUEX_ROUTING_ENTER_JOB'
export const VUEX_ROUTING_ENTER_JOB_ROUTING_BOARD         = 'VUEX_ROUTING_ENTER_JOB_ROUTING_BOARD'
export const VUEX_ROUTING_ENTER_JOBS                      = 'VUEX_ROUTING_ENTER_JOBS'
export const VUEX_ROUTING_ENTER_LOGIN                     = 'VUEX_ROUTING_ENTER_LOGIN'
export const VUEX_ROUTING_ENTER_MEMO                      = 'VUEX_ROUTING_ENTER_MEMO'
export const VUEX_ROUTING_ENTER_MEMOS                     = 'VUEX_ROUTING_ENTER_MEMOS'
export const VUEX_ROUTING_ENTER_ONBOARDING_REQUEST_ACCESS = 'VUEX_ROUTING_ENTER_ONBOARDING_REQUEST_ACCESS'
export const VUEX_ROUTING_ENTER_ONBOARDING_VERIFY_EMAIL   = 'VUEX_ROUTING_ENTER_ONBOARDING_VERIFY_EMAIL'
export const VUEX_ROUTING_ENTER_ORGANIZATION_DIRECTORY    = 'VUEX_ROUTING_ENTER_ORGANIZATION_DIRECTORY'
export const VUEX_ROUTING_ENTER_REQUESTS                  = 'VUEX_ROUTING_ENTER_REQUESTS'
export const VUEX_ROUTING_ENTER_RESET_PASSWORD            = 'VUEX_ROUTING_ENTER_RESET_PASSWORD'
export const VUEX_ROUTING_ENTER_ROUTE                     = 'VUEX_ROUTING_ENTER_ROUTE'
export const VUEX_ROUTING_ENTER_ROUTE_SUCCESS             = 'VUEX_ROUTING_ENTER_ROUTE_SUCCESS'
export const VUEX_ROUTING_ENTER_TOOLS_ALLOCATION          = 'VUEX_ROUTING_ENTER_TOOLS_ALLOCATION'
export const VUEX_ROUTING_ENTER_UNAUTHENTICATED_ROUTE     = 'VUEX_ROUTING_ENTER_UNAUTHENTICATED_ROUTE'
export const VUEX_ROUTING_ENTER_USER_CREATE               = 'VUEX_ROUTING_ENTER_USER_CREATE'
export const VUEX_ROUTING_ENTER_USER_REQUEST_ACCESS       = 'VUEX_ROUTING_ENTER_USER_REQUEST_ACCESS'
export const VUEX_ROUTING_ENTER_USER_UPDATE               = 'VUEX_ROUTING_ENTER_USER_UPDATE'
export const VUEX_ROUTING_ENTER_USERS                     = 'VUEX_ROUTING_ENTER_USERS'
export const VUEX_ROUTING_EXIT_CALENDAR_ITEM              = 'VUEX_ROUTING_EXIT_CALENDAR_ITEM'
export const VUEX_ROUTING_EXIT_DOC                        = 'VUEX_ROUTING_EXIT_DOC'
export const VUEX_ROUTING_EXIT_EVENT                      = 'VUEX_ROUTING_EXIT_EVENT'
export const VUEX_ROUTING_EXIT_JOB                        = 'VUEX_ROUTING_EXIT_JOB'
export const VUEX_ROUTING_EXIT_JOBS                       = 'VUEX_ROUTING_EXIT_JOBS'
export const VUEX_ROUTING_ENTER_PREMEDIA_SEARCH           = 'VUEX_ROUTING_ENTER_PREMEDIA_SEARCH'
export const VUEX_ROUTING_EXIT_REQUEST                    = 'VUEX_ROUTING_EXIT_REQUEST'
export const VUEX_ROUTING_EXIT_MEMO                       = 'VUEX_ROUTING_EXIT_MEMO'
export const VUEX_ROUTING_EXIT_USER                       = 'VUEX_ROUTING_EXIT_USER'
export const VUEX_ROUTING_EXIT_USER_DIRECTORY             = 'VUEX_ROUTING_EXIT_USER_DIRECTORY'
export const VUEX_ROUTING_SET_PREVIOUS_ENVIRONMENT        = 'VUEX_ROUTING_SET_PREVIOUS_ENVIRONMENT'
export const VUEX_ROUTING_UNSET_PREVIOUS_ENVIRONMENT      = 'VUEX_ROUTING_UNSET_PREVIOUS_ENVIRONMENT'
export const VUEX_ROUTING_PUSH_ROUTE_NAME                 = 'VUEX_ROUTING_PUSH_ROUTE_NAME'

export const VUEX_ROUTING_ENTER_WIP                       = 'VUEX_ROUTING_ENTER_WIP'
